export const ANIMATION_DURATIONS = {
  LIKE: 1000, // in milliseconds
  BOOKMARK: 900 // in milliseconds
}

export const TOOLTIP_DELAY = 1000; // in milliseconds